import React, { useState } from 'react';
import MobileLanguageInfo from '../../../components/siteadmin/MobileLanguageInfo/MobileLanguageInfo';

function ManageMobileLanguage({ appType }) {
  return (
    <MobileLanguageInfo
      appType={appType}
    />
  );
}

export default ManageMobileLanguage;
